import gql from 'graphql-tag';
import {priceDetailsFragments} from '@homeaway/react-price-details';

const priceDetailsContainerFragments = {
    CheckoutExperianceModel: gql`
        fragment PriceDetailsContainerCheckoutExperianceModel on CheckoutExperianceModel {
            priceDetails {
                averageNightlies {
                    perNightCost {
                        currency
                        amount
                        localized
                    }
                    type
                }
                checkoutUrl
                dueNow {
                    title
                    amount
                    tooltips {
                        title
                        amount
                        tooltip
                    }
                }
                edapPriceQuotePresented
                edapQuoteSuccess
                instantBooking
                lineItems {
                    title
                    mixedCurrencyDisclaimer
                }
                notes {
                    description
                }
                payments {
                    viewUrl
                }
                totalNumeric {
                    totalInCents
                }
                ...PriceDetailsPriceDetails
            }
        }
        ${priceDetailsFragments.PriceDetails}
    `
};

export {priceDetailsContainerFragments};
